function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import './register.scss';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Redirect from 'shared/components/Redirect';
import HardRedirect from 'researcher/components/HardRedirect';
import IdentifyPage from 'researcher/application/components/IdentifyPage';
import { T, useTranslate } from 'shared/helper/translate';
import PreferredGroupWelcome from 'researcher/components/PreferredGroupWelcome';
import featureEnabled from 'shared/helper/feature';
import LocalAuthEnabled from './LocalAuthEnabled';
import Providers from './Providers';
import RegisterForm from './RegisterForm';
import RegisterV2 from './RegisterV2';
var Register = function Register(_ref) {
  var _searchParams$get;
  var initialFormData = _ref.initialFormData,
    localAuthEnabled = _ref.localAuthEnabled,
    match = _ref.match,
    providers = _ref.providers,
    referringUrl = _ref.referringUrl,
    user = _ref.user;
  var _useState = useState(user.loggedIn ? user.homeDirectory : null),
    _useState2 = _slicedToArray(_useState, 2),
    redirect = _useState2[0],
    setRedirect = _useState2[1];
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var showNewLogin = featureEnabled('rubriq_ui_revamp');
  var origin = (_searchParams$get = searchParams.get('origin')) !== null && _searchParams$get !== void 0 ? _searchParams$get : null;
  var _useTranslate = useTranslate(),
    translationExists = _useTranslate.translationExists;
  useEffect(function () {
    if (initialFormData !== null && initialFormData !== void 0 && initialFormData.error) {
      setRedirect('/login/failure/oauth-failure');
    }
  }, []);
  if (user !== null && user !== void 0 && user.loggedIn && initialFormData !== null && initialFormData !== void 0 && initialFormData.externalRedirect) {
    window.location.href = initialFormData.externalRedirect;
  }
  var loginLink = referringUrl ? "/login?redirect=".concat(referringUrl) : '/login';
  if (origin) {
    loginLink = loginLink.concat(referringUrl ? '&' : '?', "origin=".concat(origin));
  }
  if (redirect) {
    if (redirect.includes('/c/')) {
      return /*#__PURE__*/React.createElement(HardRedirect, {
        to: redirect
      });
    }
    return /*#__PURE__*/React.createElement(Redirect, {
      to: redirect
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, !showNewLogin ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PreferredGroupWelcome, null), /*#__PURE__*/React.createElement(LocalAuthEnabled, {
    className: "container register new-button-styles ".concat(providers.length > 0 ? 'has-providers' : ''),
    redirect: !localAuthEnabled && !initialFormData,
    providers: providers,
    referringUrl: referringUrl
  }, /*#__PURE__*/React.createElement(IdentifyPage, {
    title: initialFormData ? 'Confirm your information' : 'Create your account'
  }), initialFormData ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-10 offset-md-1"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Confirm your information"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "confirm-information-message"
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-10 offset-md-1"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Create your account"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, translationExists('one account for aje and curie') && /*#__PURE__*/React.createElement(T, {
    source: "one account for aje and curie"
  }), /*#__PURE__*/React.createElement(T.md, {
    source: "account-registration-message-ref",
    useLink: true,
    params: {
      loginLink: loginLink
    }
  })))), /*#__PURE__*/React.createElement(Providers, {
    providers: providers
  })), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 offset-md-3"
  }, !initialFormData ? /*#__PURE__*/React.createElement("h4", {
    className: "text-center form-header"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Or fill out this form to create a new account"
  })) : null, /*#__PURE__*/React.createElement(RegisterForm, {
    formData: initialFormData,
    match: match,
    onSuccessfulRegistration: setRedirect,
    referringUrl: referringUrl
  }))))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RegisterV2, {
    formData: initialFormData,
    providers: providers,
    referringUrl: referringUrl,
    onSuccessfulRegistration: setRedirect
  })));
};
export default Register;